/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ThreadLockIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACKklEQVR4nLWUO2sUURTHV/BBoraKCSaWYgRBLHzFLTSwZO95zMKdc0ZTiMV2mjqdJE0aY2mjpfgBtDCt4geIAUFjp9gYsfAFxqiceegwzizsOnvhwsy9d87v/P/n3Gk0+hwAepBIjjSGMdptP44s74H0K2J4qXYAoj8GJN+R9ddQIERyGEjeGGAoECRdz4IPBYKkq0XAf0NmZub2BsGVQ/bcbDZ3AslNZN2qDQKs94FkG1hWvPcjtuY4OgOkr2uBAMnVXOe8hE54ztYRcT+Q3BsIYpcJWCPv/e444yA8iSxrSQDZBtJbmRpg6QDJZl8QILmTHJY1C25rBkPWxbwaIjmbqNGxYgMYZLZzefLvBWJZAdApe28H4Qlk3UgztoCLeTXA8rxEzQ5kmUeSb+nepjkR22HXPybbZqA37LBzbhRZbluQMjVAspR1k6lpB+Hx1N6pfLINkxF7lpfH8jhrTcfReSR5VamG9AFRNGtFr/QcMbyALJ8LkI9W6DTjEWRdBtIfiVJdR9RTfbWjVb2oJJ13vff7/lWjH7rd7q74W5Z5IHmXTL0+CGQDgvB0DHFu1AqLrNfsnUimU1UPgeQRsv60RHraBaSfSiBbZlOWdTaAdcH2W63WHpuJvbrQ0y5HchFZv5T92Kzfc8GflZ5JOvLpQBAgffFHbVXwdPYEVEDeOucnagMUIXYPXCc6WisgD4l/aqhjtQNiiPMTQTB3IL9mhawKDqxP7NBvORXzLfv39mgAAAAASUVORK5CYII=)
 */
export const ThreadLockIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M12 2.81a1 1 0 0 1 0-1.41l.36-.36a1 1 0 0 1 1.41 0l9.2 9.2a1 1 0 0 1 0 1.4l-.7.7a1 1 0 0 1-1.3.13l-9.54-6.72a1 1 0 0 1-.08-1.58l1-1L12 2.8ZM12 21.2a1 1 0 0 1 0 1.41l-.35.35a1 1 0 0 1-1.41 0l-9.2-9.19a1 1 0 0 1 0-1.41l.7-.7a1 1 0 0 1 1.3-.12l9.54 6.72A1 1 0 0 1 13 19v.15a1 1 0 0 1-.35.69l-1 1 .35.36ZM14.66 16.32c.1-.39.26-.75.45-1.09l-8.2-5.47a1 1 0 1 0-1.12 1.66l8.13 5.42a3 3 0 0 1 .74-.52ZM16.43 13.8c.62-.43 1.36-.7 2.15-.78a1 1 0 0 0-.37-.43L9.73 6.93a1 1 0 0 0-1.11 1.66l7.81 5.21Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        fillRule="evenodd"
        d="M16 18h.5v-.5a2.5 2.5 0 0 1 5 0v.5h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Zm4-.5v.5h-2v-.5a1 1 0 1 1 2 0Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
